import { useState } from 'react';
import {
  ButtonBase,
  Divider,
  List,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from 'tss-react/mui';
import { NotificationSetting } from 'features/notifications/notifications.types';
import { RegionItem } from '../RegionItem/RegionItem';

type RegionCardProps = {
  title: string;
  regionSettings: NotificationSetting[];
};

const useStyles = makeStyles()((theme) => ({
  header: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: theme.spacing(2),
  },
}));

export const RegionCard = (props: RegionCardProps): JSX.Element => {
  const { regionSettings, title } = props;
  const { classes } = useStyles();
  const [expanded, setExpanded] = useState(true);

  const handleToggleExpanded = (): void => {
    setExpanded((prev) => !prev);
  };

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ButtonBase
        className={classes.header}
        onClick={handleToggleExpanded}
        aria-expanded={expanded}
        aria-controls={`region-card-body-${title}`}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          {expanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
          <Typography variant="h3" fontWeight="fontWeightBold">
            {title}
          </Typography>
        </Stack>
      </ButtonBase>

      {expanded && (
        <>
          <Divider />

          <List disablePadding id={`region-card-body-${title}`}>
            {regionSettings.map((regionSetting) => (
              <RegionItem
                key={regionSetting.region.id}
                regionSetting={regionSetting}
              />
            ))}
          </List>
        </>
      )}
    </ListItem>
  );
};
